import React, { useEffect, useMemo, useState } from "react";
import "./Contact.css";

import IBSFavicon from "../assets/favicon-ibs.png";

// ✅ ADD THESE (adjust path if your icons are in a different folder)
import FacebookIcon from "../assets/facebook.png";
import TwitterIcon from "../assets/twitter.png";

import AOS from "aos";
import "aos/dist/aos.css";

export default function Contact() {
  useEffect(() => {
    AOS.init({
      duration: 850,
      easing: "ease-out-cubic",
      once: true,
      offset: 110,
    });
  }, []);

  const [form, setForm] = useState({
    message: "",
    name: "",
    email: "",
    subject: "",
  });

  const [status, setStatus] = useState({ type: "", msg: "" });

  const faqs = useMemo(
    () => [
      {
        q: "Occupational Health Risk Management?",
        a: "Commercial management in construction ensures the planning, execution, and coordination of a construction project from the start to finish. These are often for specific projects such as building or renovation projects that are sold or leased.",
      },
      {
        q: "What is commercial management in construction?",
        a: "Commercial management in construction ensures the planning, execution, and coordination of a construction project from the start to finish. These are often for specific projects such as building or renovation projects that are sold or leased.",
      },
      {
        q: "Start a construction management?",
        a: "Commercial management in construction ensures the planning, execution, and coordination of a construction project from the start to finish. These are often for specific projects such as building or renovation projects that are sold or leased.",
      },
      {
        q: "Measure quality in construction projects?",
        a: "Commercial management in construction ensures the planning, execution, and coordination of a construction project from the start to finish. These are often for specific projects such as building or renovation projects that are sold or leased.",
      },
      {
        q: "Prepare a construction project schedule?",
        a: "Commercial management in construction ensures the planning, execution, and coordination of a construction project from the start to finish. These are often for specific projects such as building or renovation projects that are sold or leased.",
      },
    ],
    []
  );

  function updateField(e) {
    const { name, value } = e.target;
    setForm((p) => ({ ...p, [name]: value }));
  }

  function onSubmit(e) {
    e.preventDefault();

    if (!form.message.trim() || !form.name.trim() || !form.email.trim()) {
      setStatus({ type: "error", msg: "Please fill Message, Name and Email." });
      return;
    }

    setStatus({
      type: "ok",
      msg: "Message ready to send. Connect this to your backend/email API.",
    });
  }

  const MAP_QUERY = encodeURIComponent("PROTEK CONSULT Tarnaka Hyderabad 500007");
  const mapEmbedSrc = `https://www.google.com/maps?q=${MAP_QUERY}&output=embed`;

  return (
    <section className="contactWrap">
      {/* HERO */}
      <header className="contactHero" data-aos="fade-up">
        <div className="heroInner">
          <h1 className="heroTitle">Contact Us</h1>
          <div className="heroAccent" aria-hidden="true" />
          <p className="heroSub">
            Our values and discipline vaulted us to the top of our industry.
          </p>
        </div>
      </header>

      {/* CONTACT GRID */}
      <div className="contactMain">
        <div className="contactGrid">
          {/* LEFT */}
          <div className="leftPane" data-aos="fade-right">
            <div className="leftIntro">
              <div className="kicker">How can we help?</div>

              <h2 className="leftTitle">
                Quality &amp; Passion With <br />
                Contact Form
              </h2>

              <p className="leftDesc">
                Have questions or want to chat? Fill out our contact form, and we’ll put
                you in touch with the right people.
              </p>
            </div>

            <form className="formCard" onSubmit={onSubmit}>
              <label className="field">
                <textarea
                  name="message"
                  value={form.message}
                  onChange={updateField}
                  placeholder="Question / Message?"
                  rows={7}
                />
              </label>

              <label className="field">
                <input
                  name="name"
                  value={form.name}
                  onChange={updateField}
                  placeholder="Complete Name"
                />
              </label>

              <label className="field">
                <input
                  type="email"
                  name="email"
                  value={form.email}
                  onChange={updateField}
                  placeholder="Email Address"
                />
              </label>

              <label className="field">
                <input
                  name="subject"
                  value={form.subject}
                  onChange={updateField}
                  placeholder="Subject"
                />
              </label>

              {status.msg && (
                <div className={`notice ${status.type}`} role="status" aria-live="polite">
                  {status.msg}
                </div>
              )}

              {/* CENTERED BUTTON */}
              <div className="sendWrap">
                <button className="sendBtn" type="submit">
                  <span className="sendLabel">Send Message</span>
                  <span className="sendArrow" aria-hidden="true">
                    →
                  </span>
                </button>
              </div>
            </form>
          </div>

          {/* RIGHT */}
          <aside className="rightPane" data-aos="fade-left">
            <div className="infoPanel infoPanelLight">
              <div className="infoTopLight">
                <div className="infoHeaderTitle">Contact Information</div>
                <div className="infoHeaderSub">Reach us anytime</div>
              </div>

              <div className="infoRows">
                <InfoRow
                  icon="pin"
                  title="Address"
                  value={
                    <>
                      Door 408, pavani anasuya towers,
                      <br />
                      Tarnaka, Hyderabad - 500007
                    </>
                  }
                />

                <InfoRow
                  icon="phone"
                  title="Telephone"
                  value={
                    <>
                      +91 903 06 45554
                      <br />
                      +91 903 07 45554
                    </>
                  }
                />

                <InfoRow icon="mail" title="Email" value={<>info@ibs.ind.in</>} />
              </div>

              {/* ✅ ICON-ONLY SOCIAL LINKS (IMAGES) */}
              <div className="socialIcons" aria-label="Social links">
                <a
                  className="socialIconBtn"
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Facebook"
                  title="Facebook"
                >
                  {/* ✅ facebook gets extra class */}
                  <img
                    className="socialIconImg fb"
                    src={FacebookIcon}
                    alt=""
                    aria-hidden="true"
                  />
                </a>

                <a
                  className="socialIconBtn"
                  href="https://twitter.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  aria-label="Twitter"
                  title="Twitter"
                >
                  <img className="socialIconImg" src={TwitterIcon} alt="" aria-hidden="true" />
                </a>
              </div>
            </div>
          </aside>
        </div>

        {/* BELOW CONTACT GRID: FAQ + MAP */}
        <section className="belowGrid">
          {/* FAQ */}
          <div className="faqWrap" data-aos="fade-up">
            <div className="faqTop">
              <img className="faqLogo" src={IBSFavicon} alt="IBS logo" />
              <div className="faqKicker">FREQUENTLY ASKED QUESTION</div>
              <h3 className="faqTitle">
                Finding Solutions <br />
                For Your Dream <br />
                House
              </h3>
            </div>

            <div className="faqList">
              {faqs.map((item, idx) => (
                <details
                  className="faqItem"
                  key={item.q}
                  data-aos="fade-up"
                  data-aos-delay={idx * 70}
                >
                  <summary className="faqQ">
                    <span>{item.q}</span>
                    <span className="chev" aria-hidden="true">
                      ▾
                    </span>
                  </summary>
                  <div className="faqA">{item.a}</div>
                </details>
              ))}
            </div>
          </div>

          {/* MAP */}
          <div className="mapWrap" data-aos="fade-up" data-aos-delay="120">
            <div className="mapFrame">
              <iframe
                title="PROTEK CONSULT Location Map"
                src={mapEmbedSrc}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
              />
            </div>

            <div className="mapActions">
              <button
                type="button"
                className="mapBtn"
                onClick={() =>
                  window.open(
                    "https://www.google.com/maps/place/PROTEK+CONSULT/@17.42507,78.535752,831m/data=!3m1!1e3!4m6!3m5!1s0x3bcb9960394cb051:0x86f8c5c2389c2a05!8m2!3d17.4250703!4d78.5357516!16s%2Fg%2F11vm7w9gpk?hl=en&entry=ttu&g_ep=EgoyMDI2MDEwNy4wIKXMDSoASAFQAw%3D%3D",
                    "_blank",
                    "noopener,noreferrer"
                  )
                }
              >
                Open in Google Maps
              </button>
            </div>
          </div>
        </section>
      </div>
    </section>
  );
}

function InfoRow({ icon, title, value }) {
  return (
    <div className="infoRowLight">
      <div className="infoIcoLight" aria-hidden="true">
        {icon === "pin" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M12 22s7-4.6 7-12a7 7 0 1 0-14 0c0 7.4 7 12 7 12Z"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        )}
        {icon === "phone" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path
              d="M7 2h10a2 2 0 0 1 2 2v16a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2Z"
              stroke="currentColor"
              strokeWidth="2"
            />
            <path
              d="M10 19h4"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
        )}
        {icon === "mail" && (
          <svg viewBox="0 0 24 24" fill="none">
            <path d="M4 6h16v12H4V6Z" stroke="currentColor" strokeWidth="2" />
            <path d="m4 7 8 6 8-6" stroke="currentColor" strokeWidth="2" />
          </svg>
        )}
      </div>

      <div className="infoTextLight">
        <div className="infoTitleLight">{title}</div>
        <div className="infoValueLight">{value}</div>
      </div>
    </div>
  );
}
